module.exports = __webpack_public_path__ + "afa3ffb93c6b6ba5c228ef791923cb19.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/psyker-blast.webm
// module id = 642
// module chunks = 0